module.exports = __webpack_public_path__ + "img/map_location_rose.dbddcdbf.svg";